import { render, staticRenderFns } from "./MetAlalertList.vue?vue&type=template&id=4ea4f0b3&scoped=true"
import script from "./MetAlalertList.vue?vue&type=script&lang=js"
export * from "./MetAlalertList.vue?vue&type=script&lang=js"
import style0 from "./MetAlalertList.vue?vue&type=style&index=0&id=4ea4f0b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea4f0b3",
  null
  
)

export default component.exports